(ns portal.user-account-page.view.change-password
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.panel :refer [panel]]
            [portal.user-account-page.db.change-password :as form]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui validation-item [{:keys [check message]}]
  ($ Box {:display "flex" :alignItems "center" :gap 1}
     (if check
       ($ Icon {:fontSize "small" :color "success"} "check")
       ($ Icon {:fontSize "small" :color "error"} "close"))
     message))

(defui password-validation []
  (let [has-enough-chars? (use-subscribe [:form.change-password/has-enough-chars?])
        has-uppercase? (use-subscribe [:form.change-password/has-uppercase?])
        has-lowercase? (use-subscribe [:form.change-password/has-lowercase?])
        has-digit? (use-subscribe [:form.change-password/has-digit?])]
    ($ Alert {:severity "info"
              :icon false}
       ($ validation-item
          {:check has-enough-chars?
           :message "Your password be at least 8 characters long"})
       ($ validation-item
          {:check has-uppercase?
           :message "Your password must contain at least 1 uppercase character"})
       ($ validation-item
          {:check has-lowercase?
           :message "Your password must contain at least 1 lowercase character"})
       ($ validation-item
          {:check has-digit?
           :message "Your password must contain at least 1 number"}))))

(defui change-password-form []
  (let [errors? (use-subscribe [:form.change-password/errors?])
        backend-error (use-subscribe [:form.change-password/backend-error])
        has-new? (use-subscribe [:form.change-password/has-new?])]
    ($ :form
       {:onSubmit (fn [e]
                    (.preventDefault e)
                    (rf/dispatch [:form.change-password/submit]))}
       ($ panel {:title "Reset password"
                 :actions ($ Button
                             {:variant "contained"
                              :disabled errors?
                              :type "submit"
                              :data-testid "reset-password-button"}
                             "Reset Password")}
          ($ Stack
             {:spacing 2
              :sx #js {:width "38rem"}}
             (when (or has-new? backend-error)
               ($ Stack
                  {:spacing 1}
                  (when backend-error
                    ($ Alert {:severity "error"}
                       backend-error))
                  (when has-new?
                    ($ password-validation))))

             ($ form-field
                {:label "Old password"
                 :err-msg (form/use-error-message [:old-password])
                 :data-testid "old-password-field"}
                ($ input
                   (merge (form/use-bind-control [:old-password])
                          {:type "password"})))

             ($ form-field
                {:label "New password"
                 :err-msg (form/use-error-message [:new-password])
                 :data-testid "new-password-field"}
                ($ input
                   (merge (form/use-bind-control [:new-password])
                          {:type "password"})))

             ($ form-field
                {:label "Repeat password"
                 :err-msg (form/use-error-message [:repeat-password])
                 :data-testid "repeat-password-field"}
                ($ input
                   (merge (form/use-bind-control [:repeat-password])
                          {:type "password"}))))))))
